
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'

import Scroll from '@/components/scroller'
import config from '@/config/index'
import { getCategory, getNewslist } from '@/api/youzheng.js'
import { operateCreditlist } from '@/api/user.js'
import { getaddlog } from '@/api/hgfw'
export default {
name: 'funvjie',
directives: {
TransferDom
},
data () {
return {
baseUrl: config.baseUrl,
owner_type: config.owner_type,
categorylist: [],
newslist: [],

notFirstLoad: false,
loadMoreDom: null,
pagecurent: 1,
pagesize: 20,
category: this.$route.params.category,
show: false,
imgurl: '',
imglist: [],
getBarWidth: function (index) {
}
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
created () {

},
components: {
Tab,
TabItem,
Flexbox,
FlexboxItem,
Scroll,
XDialog,
Previewer
},
watch: {





},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getlist(this.category, this.pagesize, 1)
this.addLog()
},
methods: {







logIndexChange (arg) {
},











gotoContent (ID) {
this.$router.push({ name: 'yzDetail', params: { type: ID } })
},
getlist (CATEGORYCODE, pagesize, pagecurent, type, done) {
getNewslist({
CATEGORYCODE: CATEGORYCODE,
pageSize: pagesize,
pageCurrent: pagecurent,
CHANNELCODE: 'ch15',
owner_type: config.owner_type,
searchValue: ''
}).then(res => {
if (type === 'refresh' || type === 'search') {
this.imglist = []
this.newslist = []
this.listDom.scrollTop = 0
}
if (res.obj !== '' && res.obj.length > 0) {
res.obj.forEach(item => {
this.newslist.push(item)
if (item.mobileTitleImgURL !== null) {
this.imglist.push({
msrc: this.baseUrl + item.mobileTitleImgURL,
src: this.baseUrl + item.mobileTitleImgURL
})
}
})
}
if (res.obj.length === 0 && pagecurent == 1) {
this.loadMoreDom.style.display = 'none'
this.notFirstLoad = true
} else {
this.loadMoreDom.style.display = 'flex'
this.notFirstLoad = false
}
if (
res.obj.length === 0 ||
res.obj.length < pagesize
) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
},










refresh (done, index) {
this.pagecurent = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist(this.category, this.pagesize, this.pagecurent, 'refresh', done)
},

loadMore (done, index) {
this.pagecurent++
this.getlist(this.category, this.pagesize, this.pagecurent, 'more', done)
},
imgbig (index) {
this.$refs.previewer.show(index)
},













addLog () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120125
})
}
}
}
